import React, { useEffect, useState } from "react";
import moment from "moment-timezone";
import Datetime from "react-datetime";
import {
  CalendarIcon,
  CheckIcon,
  KeyIcon,
  MailIcon,
} from "@heroicons/react/solid";
import {
  Col,
  Row,
  Card,
  Form,
  Button,
  InputGroup,
  Modal,
  Table,
  FormCheck,
  ToastContainer,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import Select from "react-select";
import axios from "axios";
import CopyToClipboard from "react-copy-to-clipboard";
import { XCircleIcon } from "@heroicons/react/outline";
import {
  useUserOnboardingMutation,
  useUserTypeMutation,
  useCheckUserDetailsMutation,
  useUserUpdateFieldMutation,
  useUserDropDownMutation,
  useGetEUforEAMutation,
  useCountriesOptionsMutation,
} from "Services/services";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { CiEdit } from "react-icons/ci";
import { Toast } from "react-bootstrap";

// import { UserOnboardingListTable } from "./Tables";
import { MdOutlineAutoMode } from "react-icons/md";
import { Routes } from "routes";
import FeaturesManagement from "./Roles";
import { useHistory } from "react-router-dom";
import { FaCircleInfo } from "react-icons/fa6";
import TableWrapper from "components/TableWrapper";

export default () => {
  const history = useHistory();
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastVariant, setToastVariant] = useState("success");
  const [enterpriseName, setEnterpriseName] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [birthday, setBirthday] = useState("");
  const [coordinatedCrm, setCoordinatedCrm] = useState();
  const [fetchedCrm, setFetchedCrm] = useState(null);
  const [coordinatedEditCrm, setCoordinatedEditCrm] = useState(null);

  const [userType, setUserType] = useState(null);
  const [crmValue, setCrmValue] = useState(null);
  const [selectUserTypeOptions, setSelectUserTypeOptions] = useState({
    value: "",
    label: "Select Enterprise",
  });
  const [editDetails, setEditDetails] = useState([]);
  const [selectedCrmOptions, setSelectedCrmOptions] = useState({
    value: "",
    label: "Select CRM",
  });
  const [selectedCrmEditOptions, setSelectedCrmEditOptions] = useState([]);

  const [showEdit, setShowEdit] = useState(false);
  const [isEditingPassword, setIsEditingPassword] = useState(false);
  const [isEditPassword, setIsEditPassword] = useState(false);
  const [refreshTable, setRefreshTable] = useState(false);
  const [countryOptions, setCountryOptions] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [currency, setCurrency] = useState(null);
  const [international, setInternational] = useState(false);

  const [showDefault, setShowDefault] = useState(false);
  const [showEditDefault, setShowEditDefault] = useState(false);
  const [copied, setCopied] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const selectClassificationOptions = [
    { value: "1", label: "Government" },
    { value: "2", label: "Charity" },
    { value: "3", label: "Private" },
    { value: "4", label: "International" },
  ];
  const [classification, setClassification] = useState(null);
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [savedPermissions, setSavedPermissions] = useState([]);
  const [users, setUsers] = useState(null);
  const [entUsers, setEntUsers] = useState(null);
  const [user, setUser] = useState(null);
  const [entCrm, setEntCrm] = useState([]);
  const [entUser, setEntUser] = useState(null);
  const [enterpriseUserID, setEnterpriseUserID] = useState([]);

  const [userOnboard] = useUserOnboardingMutation();
  const [usertype] = useUserTypeMutation();
  const [crmData] = useUserDropDownMutation();
  const [userDetailUpdates] = useUserUpdateFieldMutation();
  const [verify] = useCheckUserDetailsMutation();
  const [userDropDown] = useUserDropDownMutation();
  const [getCountries] = useCountriesOptionsMutation();
  const [geteu] = useGetEUforEAMutation();

  const [validationError, setValidationError] = useState({
    usertype: false,
    enterprise: false,
    name: false,
    username: false,
    phone: false,
    email: false,
    password: false,
    date: false,
    crm: false,
    country: false,
    classif: false,
    entUser: false,
    currency: false,
  });

  // Get the usertype from localStorage
  const loggedUserData = localStorage.getItem("TOKEN");
  const userObject = JSON.parse(loggedUserData);
  const loggedUserType = userObject.user_type;
  const loggedUserId = userObject.id;

  // Handle save from FeaturesManagement
  const handleSaveFeatures = (permissions) => {
    setSavedPermissions(permissions);
  };

  const RequiredLabel = ({ label }) => (
    <Form.Label>
      {label}
      <span className="text-danger"> * </span>
    </Form.Label>
  );

  useEffect(() => {
    fetchCurrencies();
    // fetchTableData();
    fetchUserTypeData();
    fetchCountries();
    fetchUserDropdown();

    if (loggedUserType === "enterprise") {
      // setCoordinatedCrm({});
      setFetchedCrm({
        value: userObject.crm_id,
        label: userObject.crm_name,
      });
    }
    // If you're fetching classification and options from API
    if (loggedUserType === "enterprise") {
      const found = selectClassificationOptions.find(
        (opt) => opt.label === userObject.classification
      );
      setClassification(found);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if ((crmValue === "8" && loggedUserType === "enterprise") || user?.value) {
      fetchEUDropdown();
    } else if (crmValue === "4") fetchCrmData();
  }, [crmValue, user]);

  useEffect(() => {
    const user = (crmValue === "4" || crmValue === "7");
    const country = (selectedCountry?.value==="Saudi Arabia" || selectedCountry?.value==="United Arab Emirates");
    if (user && country) {
      setInternational(true);
    } else {
      setInternational(false);
    }
  }, [selectedCountry, crmValue]);

  const fetchCurrencies = async () => {
    try {
      const response = await axios.get(
        "https://openexchangerates.org/api/currencies.json",
        {
          params: {
            app_id: "YOUR_API_KEY", // Replace with your actual API key
          },
        }
      );
      const currencies = Object.entries(response.data).map(([key, value]) => ({
        value: key,
        label: `${key} - ${value}`,
      }));
      setCurrencyOptions(currencies);
      // setCurrency(currencies[66]);
    } catch (error) {
      setCurrencyOptions([]);
      console.error("Error fetching currency data:", error);
    }
  };

  const fetchCountries = async () => {
    try {
      const response = await getCountries({ cname: "" });
      if (response?.data?.statusCode === 200) {
        const options = response.data.data.countries.map((item) => ({
          value: item.name,
          label: `${item.name} (${item.dialCode}) `,
        }));
        setCountryOptions(options);
      } else if (response.data.error) {
        console.error("API returned an error:", response.data.msg);
        setCountryOptions([]);
      }
    } catch (error) {
      setCountryOptions([]);
      console.error("Error fetching country data:", error);
    }
  };

  const fetchUserTypeData = async () => {
    try {
      const response = await usertype();
      if (response?.data?.statusCode === 200) {
        const allOptions = response.data.data.user_type_details.map((user) => ({
          value: user.id,
          label: user.user_type,
        }));

        // Filter options if logged user is an admin or enterprise
        const filteredOptions =
          loggedUserType === "admin"
            ? allOptions.filter((option) => option.label !== "admin")
            : loggedUserType === "enterprise"
            ? allOptions.filter(
                (option) =>
                  option.label === "enterprise_user" ||
                  option.label === "enterprise_reporting_user"
              )
            : allOptions;

        setSelectUserTypeOptions(filteredOptions);

        // // Set the default userType to the placeholder
        // setUserType(optionsWithPlaceholder[0]);
      } else {
        setSelectUserTypeOptions([]);
        console.error("Failed to fetch user data");
      }
    } catch (error) {
      setSelectUserTypeOptions([]);
      console.error("Error fetching user data", error);
    }
  };

  const fetchCrmData = async () => {
    try {
      const response = await crmData({ user_type: 3 });
      if (response?.data?.statusCode === 200) {
        console.log("response", response);
        const options = response.data.data.user_details.map((user) => ({
          value: user.id,
          label: `${user.user_name} (${user.email})`,
        }));
        // Add a default "Select CRM" option at the beginning of the options array
        setSelectedCrmOptions([
          { value: "", label: "Select CRM" },
          ...options,
        ]);
      } else {
        setSelectedCrmOptions([]);
        // console.error("Failed to fetch user data");
      }
    } catch (error) {
      setSelectedCrmOptions([]);
      // console.error("Error fetching user data", error);
    }
  };

  const fetchUserDropdown = async () => {
    userDropDown({ user_type: "4" })
      .then((response) => {
        if (response?.data?.statusCode === 200) {
          const userOptions = response.data.data.user_details.map((user) => ({
            value: user.id,
            label: user.user_name,
          }));
          setUsers(userOptions);
          const userCrmOptions = response.data.data.user_details.map(
            (user) => ({
              label: user.customer_relation_manager_name,
              value: user.customer_relation_manager,
              entId: user.id,
            })
          );
          setEntCrm(userCrmOptions);
        } else {
          setEntCrm([]);
          console.error("Failed to fetch user data");
        }
      })
      .catch((error) => {
        setEntCrm([]);
        console.error("Error fetching user data", error);
      });
  };

  const findCrm = (eId) => {
    const found = entCrm.filter((user) => user.entId === eId);
    // console.log('found', found);
    setFetchedCrm(found);
  };

  const fetchEUDropdown = () => {
    geteu({
      user_id: loggedUserType === "enterprise" ? loggedUserId : user?.value,
    })
      .then((response) => {
        if (response?.data?.statusCode === 200) {
          const userOptions = response.data.data.dropDownData.map((user) => ({
            value: parseInt(user.id),
            label: user.user_name,
          }));
          setEntUsers(userOptions);
        } else {
          setEntUsers([]);
          // console.error("Failed to fetch user data");
        }
      })
      .catch((error) => {
        setEntUsers([]);
        console.error("Error fetching user data", error);
      });
  };

  const generatePassword = () => {
    const length = 12;
    const lower = "abcdefghijklmnopqrstuvwxyz";
    const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const numbers = "0123456789";
    const symbols = "@$!%*?&#^";
  
    const all = lower + upper + numbers + symbols;
  
    let password = "";
    password += lower[Math.floor(Math.random() * lower.length)];
    password += upper[Math.floor(Math.random() * upper.length)];
    password += numbers[Math.floor(Math.random() * numbers.length)];
    password += symbols[Math.floor(Math.random() * symbols.length)];
  
    for (let i = 4; i < length; i++) {
      password += all[Math.floor(Math.random() * all.length)];
    }
  
    // Shuffle password to remove predictable pattern
    password = password
      .split("")
      .sort(() => 0.5 - Math.random())
      .join("");
  
    setPassword(password);
    setValidationError((prev) => ({
      ...prev,
      password: false,
    }));
  };

  const handleCopy = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  const handleClose = () => {
    setShowDefault(false);
    setShowEditDefault(false);
    setShowEdit(false);
  };

  const handleCloseBack = () => {
    setShowEditDefault(false);
    setShowEdit(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let hasError = false;

    // Validate User Type
    if (!userType?.value) {
      setValidationError((prev) => ({ ...prev, usertype: true }));
      hasError = true;
    }

    if (
      loggedUserType !== "enterprise" &&
      (crmValue == "7" || crmValue == "8") &&
      (!user || !user?.value)
    ) {
      setValidationError((prev) => ({ ...prev, enterprise: true }));
      hasError = true;
    }

    if (!name) {
      setValidationError((prev) => ({ ...prev, name: true }));
      hasError = true;
    }

    if (!enterpriseName) {
      setValidationError((prev) => ({ ...prev, username: true }));
      hasError = true;
    }

    if (!phone) {
      setValidationError((prev) => ({ ...prev, phone: true }));
      hasError = true;
    }

    if (!email) {
      setValidationError((prev) => ({ ...prev, email: true }));
      hasError = true;
    }

    if (!password) {
      setValidationError((prev) => ({ ...prev, password: true }));
      hasError = true;
    }

    if (!birthday) {
      setValidationError((prev) => ({ ...prev, date: true }));
      hasError = true;
    }

    // Validate Coordinated CRM (Only when crmValue is 4)
    if (crmValue == 4 && (!coordinatedCrm || !coordinatedCrm?.value)) {
      setValidationError((prev) => ({ ...prev, crm: true }));
      hasError = true;
    }

    // Validate Country
    if (!selectedCountry || !selectedCountry?.value) {
      setValidationError((prev) => ({ ...prev, country: true }));
      hasError = true;
    }

    // Validate Classification
    if ((crmValue == 4 || crmValue == 7) && (selectedCountry?.value==="Saudi Arabia" || selectedCountry?.value==="United Arab Emirates") && !classification) {
      setValidationError((prev) => ({ ...prev, classif: true }));
      hasError = true;
    }
    // Validate ent
    if (crmValue == 8 && (!entUser || !entUser[0]?.value)) {
      setValidationError((prev) => ({ ...prev, entUser: true }));
      hasError = true;
    }

    if (!currency?.value) {
      setValidationError((prev) => ({ ...prev, currency: true }));
      hasError = true;
    }

    // Stop submission if any validation failed
    if (hasError) {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // or 'auto' if you want instant scroll
      });
      return; // prevent form from submitting
    } else {
      setValidationError({});
      setShowDefault(true);
    }
  };

  const handleEditSubmit = (e) => {
    e.preventDefault();
    setShowEdit(false);
    setShowEditDefault(true);
  };

  const userData = {
    user_name: enterpriseName,
    name: name,
    phone: phone,
    email: email,
    password: password,
    expiry_date: birthday,
    customer_relation_manager:
      crmValue === "7" || crmValue === "8"
        ? fetchedCrm && (fetchedCrm.value || fetchedCrm[0]?.value)
        : coordinatedCrm?.value || coordinatedCrm,
    user_type: userType?.value,
    user_currency: currency?.value,
    classification:
      crmValue === "7" || crmValue === "4" ? classification?.label : "",
    country: selectedCountry?.value,
    features: savedPermissions,
    associated_enterprise_id:
      loggedUserType === "enterprise"
        ? loggedUserId
        : crmValue === "7" || crmValue === "8"
        ? user?.value
        : null,
    reported_enterprise: crmValue === "8" ? enterpriseUserID : null,
  };

  const submitForm = (e) => {
    e.preventDefault();
    userOnboard(userData)
      .then((success) => {
        if (success?.data?.statusCode === 200) {
          setShowDefault(false);
          setToastMessage(success?.data?.message);
          setToastVariant("success");
          setRefreshTable(!refreshTable);
          setEnterpriseName("");
          setName("");
          setPhone("+91");
          setEmail("");
          setPassword("");
          setBirthday("");
          setCoordinatedCrm(null);
          setisVerifiedUsername("");
          setisVerifiedPhone("");
          setisVerifiedEmail("");
          history.push(Routes.UserManagement.path);
        } else {
          setShowDefault(false);
          setToastMessage(success?.data?.message || success?.data?.error || "Failed!");
          setToastVariant("danger");
          setRefreshTable(!refreshTable);
        }
        setShowToast(true);
      })
      .catch((error) => {
        setShowDefault(false);
        setRefreshTable(!refreshTable);
        setToastMessage(error?.message || error?.data?.error || "Failed!");
        setToastVariant("danger");
        setShowToast(true);
      });
  };
  const [isPasswordEdited, setIsPasswordEdited] = useState(false);

  // Update this when the password input is edited
  const handlePasswordChange = (e) => {
    setEditDetails({ ...editDetails, password: e.target.value });
    setIsPasswordEdited(true); // Set to true when user starts editing the password
  };

  const userEditData = {
    name: editDetails.name,
    phone: editDetails.phone,
    email: editDetails.email,
    expiry_date: editDetails.expiry_date,
    customer_relation_manager:
      coordinatedEditCrm === null
        ? selectedCrmEditOptions[0]?.value
        : coordinatedEditCrm?.value,
    user_type: editDetails.user_type,
    user_currency: editDetails.user_currency,
    id: editDetails.id,
    ...(isPasswordEdited ? { password: editDetails.password } : {}), // Only include password if it was edited
  };

  const [passwordError, setPasswordError] = useState("");

  const submitEditForm = (e) => {
    e.preventDefault();

    // Password validation: Add your custom validation logic here
    if (editDetails.password === "" || editDetails?.password?.length < 8) {
      setPasswordError("Password must be at least 8 characters long.");
      return; // Prevent form submission if the validation fails
    }

    // Clear any previous error if password is valid
    setPasswordError("");

    // Continue with API call if password validation passes
    userDetailUpdates(userEditData)
      .then((success) => {
        if (success?.data?.statusCode === 200) {
          setShowDefault(false);
          setShowEdit(false);
          setShowEditDefault(false);
          setEditDetails([]);
          setRefreshTable(!refreshTable);
          setPhone("");
        } else if (success?.data?.statusCode > 300) {
          setShowDefault(false);
          setShowEdit(false);
          setShowEditDefault(false);
          setEditDetails([]);
          setRefreshTable(!refreshTable);
          setPhone("");
        }
      })
      .catch((error) => {
        setShowDefault(false);
        setShowEdit(false);
        setShowEditDefault(false);
        setEditDetails([]);
        setRefreshTable(!refreshTable);
        console.error("Error updating user details", error);
      });
  };

  const [isVerifiedUsername, setisVerifiedUsername] = useState();
  const [isVerifiedPhone, setisVerifiedPhone] = useState();
  const [isVerifiedEmail, setisVerifiedEmail] = useState();

  const verifyUsername = (e) => {
    const username = e.target.value;
    setEnterpriseName(username);

    const regex = /^[A-Za-z0-9]{0,30}$/;

    if (username.length >= 3 && username.length <= 12 && regex.test(username)) {
      const postData = { data: username };
      verify(postData)
        .then((success) => {
          if (success?.data?.statusCode === 200) {
            setisVerifiedUsername(true);
            setValidationError((prev) => ({ ...prev, username: false }));
          } else if (success?.data?.statusCode > 300) {
            setisVerifiedUsername(false);
            console.error("Verification failed");
          }
        })
        .catch((error) => {
          setisVerifiedUsername(false);
          console.error("Verification failed", error);
        });
    } else {
      setisVerifiedUsername(false);
      setValidationError((prev) => ({ ...prev, username: true }));
    }
  };
  const verifyEmail = (e) => {
    const email = e.target.value;
    setEmail(email);

    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (regex.test(email)) {
      const postData = { data: email };
      verify(postData)
        .then((success) => {
          if (success?.data?.statusCode === 200) {
            setisVerifiedEmail(true);
            setValidationError((prev) => ({ ...prev, email: false }));
          } else if (success?.data?.statusCode > 300) {
            setisVerifiedEmail(false);
            console.error("Verification failed");
          }
        })
        .catch((error) => {
          setisVerifiedEmail(false);
          console.error("Verification failed", error);
        });
    } else {
      setisVerifiedEmail(false);
    }
  };

  const verifyPhone = (phone) => {
    setPhone(phone);
    const regex =
      /^(\+|00)?\d{1,3}[-.\s]?\(?\d{1,4}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/;
    if (phone.length >= 6 && phone.length <= 13 && regex.test(phone)) {
      const postData = { data: phone };
      verify(postData)
        .then((success) => {
          if (success?.data?.statusCode === 200) {
            setisVerifiedPhone(true);
            setValidationError((prev) => ({ ...prev, phone: false }));
          } else if (success?.data?.statusCode > 300) {
            setisVerifiedPhone(false);
            console.error("Verification failed");
          }
        })
        .catch((error) => {
          setisVerifiedPhone(false);
          console.error("Verification failed", error);
        });
    } else {
      setisVerifiedPhone(false);
    }
  };

  const handleEdit = async (userDetails) => {
    try {
      const response = await crmData({ user_type: 3 });
      if (response?.data?.statusCode === 200) {
        const options = response.data.data.user_details.map((user) => ({
          value: user.id,
          label: `${user.user_name} (${user.email})`,
        }));

        setSelectedCrmEditOptions([
          {
            value: userDetails.customer_relation_manager,
            label: userDetails.customer_relation_manager_name,
          },
          ...options,
        ]);
      } else {
        console.error("Failed to fetch user data", response.data);
      }
    } catch (error) {
      console.error("Error fetching user data", error);
    } finally {
    }

    setEditDetails(userDetails);
    setShowEdit(true);
  };

  const handleUserTypeChange = (selectedOption) => {
    setUserType(selectedOption);
    setValidationError({ ...validationError, usertype: false }); // Clear error on valid selection
    // selectUserType(selectedOption);
    // const selectUserType = (selectedOption) => {
    // setUserType(selectedOption);
    setCrmValue(selectedOption?.value);
    setUser(null);
    // };
  };

  return (
    <>
      <ToastContainer position="top-end" className="p-3">
        <Toast
          bg={toastVariant}
          show={showToast}
          onClose={() => setShowToast(false)}
          delay={3000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">Notification</strong>
          </Toast.Header>
          <Toast.Body>{toastMessage}</Toast.Body>
        </Toast>
      </ToastContainer>

      <Card border={1} className="mb-3">
        <Card.Body className="p-0">
          <h5 className="mb-4">General information</h5>
          <Form noValidate autoComplete="off">
            <input
              type="text"
              name="preventAutoFill"
              style={{ display: "none" }}
            />
            <Row>
              <Col
                md={6} lg={4}
                className="mb-3"
              >
                <Form.Group id="userType">
                <RequiredLabel label="User Type" />
                  <Select
                    options={selectUserTypeOptions}
                    placeholder="Select User Type"
                    classNamePrefix="react-select"
                    className={`mb-0 ${
                      validationError.usertype ? "is-invalid-select" : ""
                    }`} // Add a red border on error
                    value={userType}
                    onChange={handleUserTypeChange}
                    title="Select the type of user you want to create"
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        borderColor: validationError.usertype ? '#dc3545' :  userType ? '#65BB82': '#ced4da',
                        borderRadius: '0.75rem',
                      }),
                    }}
                  />
                  {validationError.usertype && (
                    <div className="invalid-feedback d-block">
                      User Type is required.
                    </div>
                  )}
                </Form.Group>
              </Col>

              {loggedUserType !== "enterprise" &&
                (crmValue === "7" || crmValue === "8") && (
                  <Col md={6} lg={4} className="mb-3 text-left">
                    <Form.Group id="cardNameLabel">
                      <RequiredLabel label="Enterprise" />
                      <Select
                        options={users}
                        placeholder="Select User"
                        className="mb-0" 
                        isSearchable={true}
                        value={user}
                        onChange={(selectedOption) => {
                          setUser(selectedOption);
                          findCrm(selectedOption.value);
                        }}
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            borderColor: validationError.enterprise ? '#dc3545' :  user ? '#65BB82': '#ced4da',
                            borderRadius: '0.75rem',
                          }),
                        }}
                        title="Select the enterprise user to associate with this account"
                      />
                      {validationError.enterprise && (
                        <div className="invalid-feedback d-block">
                          Enterprise is required.
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                )}

              <Col
                md={6} lg={4}
                className="mb-3"
              >
                <Form.Group id="name">
                <RequiredLabel label="Name" />
                  <Form.Control
                    type="text"
                    placeholder="Enter name"
                    value={name}
                    onChange={(e) => {
                      if (/^[A-Za-z]{0,50}$/.test(e.target.value))
                        setName(e.target.value);
                      setValidationError((prev) => ({ ...prev, name: false }));
                    }}
                    maxLength={50}
                    title="Enter a valid name with 3–50 alphabetic characters only"
                    autoComplete="new-name"
                  />
                  {validationError.name && (
                    <div className="invalid-feedback d-block">
                      Name is required.
                    </div>
                  )}
                </Form.Group>
              </Col>
           
              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="username">
                <RequiredLabel label="Username" />
                  <InputGroup>
                    <Form.Control
                      type="text"
                      placeholder="Enter username"
                      value={enterpriseName}
                      onChange={verifyUsername}
                      pattern="^[A-Za-z0-9]{0,30}$"
                      title="Enter a valid username with 3–30 alphanumeric characters only"
                      maxLength={30}
                      minLength={3}
                      autoComplete="new-username"
                    />
                    {isVerifiedUsername && (
                      <InputGroup.Text title="Username is available and unique">
                        <CheckIcon width={20} className="text-success" />
                      </InputGroup.Text>
                    )}
                    {isVerifiedUsername === false && (
                      <InputGroup.Text title="Username is not available or unique">
                        <XCircleIcon width={20} className="text-danger" />
                      </InputGroup.Text>
                    )}
                    {validationError.username && (
                      <div className="invalid-feedback d-block">
                        Enter a valid username.
                      </div>
                    )}
                  </InputGroup>
                </Form.Group>
              </Col>
              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="phone">
                <RequiredLabel label="Phone" />
                  <InputGroup className="phone-input-group">
                    <PhoneInput
                      country={"in"}
                      value={phone}
                      onChange={verifyPhone}
                      title="Enter a valid phone number"
                      placeholder="+91 99999-99999"
                      className="phone-input"
                      autoComplete="new-phone"
                    />
                    {isVerifiedPhone && (
                      <InputGroup.Text className="phone-input-icon" title="Phone number is available and unique">
                        <CheckIcon width={20} className="text-success" />
                      </InputGroup.Text>
                    )}
                    {isVerifiedPhone === false && (
                      <InputGroup.Text className="phone-input-icon" title="Phone number is not available or unique">
                        <XCircleIcon width={20} className="text-danger" />
                      </InputGroup.Text>
                    )}
                  </InputGroup>
                  {validationError.phone && (
                    <div className="invalid-feedback d-block">
                      Enter a valid phone number.
                    </div>
                  )}
                </Form.Group>
              </Col>
          
              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="email">
                  <RequiredLabel label="Email" />
                  <InputGroup>
                    <InputGroup.Text>
                      <MailIcon width={20} />
                    </InputGroup.Text>
                    <Form.Control
                      type="email"
                      placeholder="name@company.com"
                      value={email}
                      onChange={verifyEmail}
                      title="Enter a valid email address"
                      autoComplete="new-email"
                    />
                    {isVerifiedEmail && (
                      <InputGroup.Text title="Email is available and unique">
                        <CheckIcon width={20} className="text-success" />
                      </InputGroup.Text>
                    )}
                    {isVerifiedEmail === false && (
                      <InputGroup.Text title="Email is not available or unique">
                        <XCircleIcon width={20} className="text-danger" />
                      </InputGroup.Text>
                    )}
                  </InputGroup>
                  {validationError.email && (
                    <div className="invalid-feedback d-block">
                      Enter a valid email address.
                    </div>
                  )}
                </Form.Group>
              </Col>
              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="password">
                <Form.Label className="d-flex align-items-center gap-1 mb-1">
                <span>Password</span>
                <span className="text-danger"> * </span>
                  <OverlayTrigger
                        placement="right"
                        overlay={
                          <Tooltip id="ip-tooltip">
                            Password must be 8-32 characters, include uppercase, lowercase, number, and special character.
                          </Tooltip>
                        }
                      >
                        <span
                          className="ms-1 text-primary"
                          style={{ cursor: "pointer" }}
                        >
                          <FaCircleInfo size={18} />
                        </span>
                      </OverlayTrigger>
                  </Form.Label>
                  <InputGroup>
                    <InputGroup.Text>
                      <KeyIcon width={20} />
                    </InputGroup.Text>
                    <Form.Control
                      type="password"
                      placeholder="Password"
                      value={password}
                      title="Password must be 8-32 characters, include uppercase, lowercase, number, and special character."
                      onChange={(e) => {
                        const newValue = e.target.value;
                        // Limit length and allow valid characters
                        if (newValue.length <= 32) {
                          setPassword(newValue);
                        
                          // Validate live feedback
                          const isValid = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^])[A-Za-z\d@$!%*?&#^]{8,32}$/.test(newValue);
                          setValidationError((prev) => ({
                            ...prev,
                            password: !isValid,
                          }));
                        }
                      }}
                      maxLength={32}
                      minLength={8}
                      autoComplete="new-password"
                    />
                    <InputGroup.Text>
                      <MdOutlineAutoMode
                        size={20}
                        onClick={generatePassword}
                        style={{ cursor: "pointer" }}
                        title="Auto-generate password"
                      />
                    </InputGroup.Text>
                  </InputGroup>
                  {validationError.password && (
                    <div className="invalid-feedback d-block">
                      Enter a valid strong password.
                    </div>
                  )}
                </Form.Group>
              </Col>

              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="birthday">
                  <RequiredLabel label="Expiry Date" />
                  <Datetime
                    timeFormat={false}
                    onChange={(date) => {
                      setBirthday(date);
                      setValidationError((prev) => ({ ...prev, date: false }));
                    }}
                    isValidDate={(currentDate) =>
                      currentDate.isAfter(moment(), "day")
                    }
                    renderInput={(props, openCalendar) => (
                      <InputGroup>
                        <InputGroup.Text>
                          <CalendarIcon className="icon icon-xs" />
                        </InputGroup.Text>
                        <Form.Control
                          required
                          type="text"
                          value={
                            birthday
                              ? moment(birthday).format("DD/MM/YYYY")
                              : ""
                          }
                          placeholder="DD/MM/YYYY"
                          onFocus={openCalendar}
                          onChange={() => {}}
                          autoComplete="new-birthday"
                        />
                      </InputGroup>
                    )}
                  />
                  {validationError.date && (
                    <div className="invalid-feedback d-block">
                      Expiry date is required.
                    </div>
                  )}
                </Form.Group>
              </Col>
           
              {(crmValue === "4" || crmValue === "7" || crmValue === "8") && (
                <Col md={6} lg={4} className="mb-3">
                  <Form.Group id="coordinatedCrm">
                    <Form.Label>Coordinated CRM</Form.Label>
                    {crmValue === "8" ||
                    crmValue === "7" ||
                    loggedUserType === "enterprise" ? (
                      <Form.Control
                        disabled
                        type="text"
                        placeholder="CRM"
                        defaultValue={
                          fetchedCrm
                            ? fetchedCrm.label || fetchedCrm[0].label
                            : ""
                        } //crm ka nam -ent login
                        title="This field is automatically populated based on your Enterprise and cannot be modified"
                      />
                    ) : (
                      <Select
                        options={selectedCrmOptions}
                        placeholder="Select User"
                        className={`mb-0 ${
                          validationError.crm ? "is-invalid-select" : ""
                        }`}
                        isSearchable={true}
                        value={coordinatedCrm}
                        onChange={(selectedOption) => {
                          setCoordinatedCrm(selectedOption);
                          if (selectedOption)
                            setValidationError({
                              ...validationError,
                              crm: false,
                            }); // Clear error on valid selection
                        }}
                      />
                    )}
                    {validationError.crm && (
                      <div className="invalid-feedback d-block">
                        CRM is required.
                      </div>
                    )}
                  </Form.Group>
                </Col>
              )}
              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="country">
                <RequiredLabel label="Country" />
                  <Select
                    options={countryOptions}
                    placeholder="Select Country"
                    className={`mb-0 ${
                      validationError.country ? "is-invalid-select" : ""
                    }`}
                    isSearchable={true}
                    value={selectedCountry}
                    onChange={(option) => {
                      setSelectedCountry(option);
                      setClassification()
                      if (option)
                        setValidationError({
                          ...validationError,
                          country: false,
                        });
                    }}
                    autoComplete="new-country"
                    title="Select the country where this user will operate"
                  />
                  {validationError.country && (
                    <div className="invalid-feedback d-block">
                      Country is required.
                    </div>
                  )}
                </Form.Group>
              </Col>
              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="currency">
                <RequiredLabel label="Currency" />
                  <Select
                    options={currencyOptions}
                    placeholder="Select Currency"
                    className="mb-0"
                    isSearchable={true}
                    value={currency || ""}
                    onChange={(currencyOption) => setCurrency(currencyOption)}
                    autoComplete="new-currency"
                    title="Select the currency for this user's transactions"
                  />
                </Form.Group>
                {validationError.currency && (
                  <div className="invalid-feedback d-block">
                    Currency is required.
                  </div>
                )}
              </Col>
              {international && (
                <Col md={6} lg={4} className="mb-3">
                  <Form.Group id="classification">
                    <RequiredLabel label="Vertical" />

                    <Select
                      isClearable
                      options={selectClassificationOptions}
                      placeholder="Select Vertical"
                      className={`mb-0 ${
                        validationError.classif ? "is-invalid-select" : ""
                      }`}
                      value={classification}
                      onChange={(selectedOption) => {
                        setClassification(selectedOption);
                        if (selectedOption)
                          setValidationError({
                            ...validationError,
                            classif: false,
                          });
                      }}
                      title="Select the business vertical classification (required for Saudi Arabia and UAE)"
                    />
                    {validationError.classif && (
                      <div className="invalid-feedback d-block">
                        Vertical is required.
                      </div>
                    )}
                  </Form.Group>
                </Col>
              )}
              {crmValue === "8" && (
                <Col md={6} lg={4} className="mb-3 text-left">
                  <Form.Group id="cardNameLabel">
                    <RequiredLabel label="Enterprise User" />
                    <Select
                      options={entUsers}
                      placeholder="Select Enterprise User"
                      className="mb-0"
                      isSearchable={true}
                      isMulti
                      value={entUser}
                      onChange={(selectedOptions) => {
                        setEntUser(selectedOptions);
                        const values =
                          selectedOptions?.map((option) => option.value) || [];
                        setEnterpriseUserID(values);
                        setValidationError({
                          ...validationError,
                          entUser: false,
                        });
                      }}
                      title="Select one or more enterprise users to associate with this account"
                    />
                    {validationError.entUser && (
                      <div className="invalid-feedback d-block">
                        Enterprise User is required.
                      </div>
                    )}
                  </Form.Group>
                </Col>
              )}
            </Row>
          </Form>
        </Card.Body>
      </Card>

      {userType!==null && <FeaturesManagement data={userType} onSave={handleSaveFeatures} customRoles={international} />}

      <div className="m-3 d-flex">
        <Button variant="secondary" onClick={handleSubmit} type="button" className="ms-auto">
          Preview
        </Button>
      </div>



      <Modal
        backdrop="static"
        keyboard={false}
        as={Modal.Dialog}
        centered
        show={showDefault}
        onHide={handleClose}
        size="lg"
      >
        <Modal.Header>
          <Modal.Title className="h6">User Detail Preview</Modal.Title>
          <Button variant="close" aria-label="Close" onClick={handleClose} />
        </Modal.Header>
        <Modal.Body style={{ width: "auto" }}>
          <Card className="m-0 mb-2">
            <Row>
              <Col md={12}>
                <Table className="table-centered table-nowrap rounded mb-0">
                  <tbody>
                    <tr>
                      <td className="border-0">Name</td>
                      <td className="border-0">{name}</td>
                    </tr>
                    <tr>
                      <td className="border-0">Username</td>
                      <td className="border-0">{enterpriseName}</td>
                    </tr>
                    <tr>
                      <td className="border-0">Phone Number</td>
                      <td className="border-0">{phone}</td>
                    </tr>
                    <tr>
                      <td className="border-0">Email</td>
                      <td className="border-0">{email}</td>
                    </tr>
                    <tr>
                      <td className="border-0">Password</td>
                      <td className="border-0">{password}</td>
                    </tr>
                    <tr>
                      <td className="border-0">Expiry Date</td>
                      <td className="border-0">
                        {birthday ? moment(birthday).format("DD/MM/YYYY") : ""}
                      </td>
                    </tr>

                    {loggedUserType !== "customer relationship manager" &&
                      crmValue === "4" && (
                        <tr>
                          <td className="border-0">Coordinated CRM</td>
                          <td className="border-0">
                            {coordinatedCrm
                              ? coordinatedCrm.label ||
                                fetchedCrm[0]?.label ||
                                fetchedCrm.label
                              : ""}
                          </td>
                        </tr>
                      )}

                    <tr>
                      <td className="border-0">User Type</td>
                      <td className="border-0">{userType?.label}</td>
                    </tr>
                    <tr>
                      <td className="border-0">User Currency</td>
                      <td className="border-0">
                        {currency ? currency.label : ""}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
                    {copied ? (
                      <Button
                        size="sm"
                        variant="success"
                        className="copy-code-button"
                      >
                        Copied
                      </Button>
                    ) : (
                      <CopyToClipboard
                        text={`Name: ${name}\nUsername: ${enterpriseName}\nPhone Number: ${phone}\nEmail: ${email}\nPassword: ${password}\nExpiry Date: ${
                          birthday ? moment(birthday).format("DD/MM/YYYY") : ""
                        }\nUser Type: ${
                          userType ? userType.label : ""
                        }\nUser Currency: ${currency ? currency.label : ""}`}
                        onCopy={handleCopy}
                      >
                        <Button
                          size="sm"
                          variant="secondary"
                          className="copy-code-button"
                        >
                          Copy
                        </Button>
                      </CopyToClipboard>
                    )}
            </Row>
          </Card>

          <Card className="m-0">
              <b>Feature Permissions</b>
              <div className="rounded-3 mt-2 align-item-center w-100">
                <TableWrapper>
                  <thead className="bg-light">
                    <tr className="bg-gray-50">
                      <th className="">Feature</th>
                      <th className="text-center">Read</th>
                      <th className="text-center">Edit</th>
                      <th className="text-center">Download</th>
                      <th className="text-center">Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    {savedPermissions.map((perm, index) => (
                      <tr key={index}>
                        <td>{perm.name}</td>
                        <td className="text-center">
                          {perm.read ? "☑️" : "✖️"}
                        </td>
                        <td className="text-center">
                          {perm.edit ? "☑️" : "✖️"}
                        </td>
                        <td className="text-center">
                          {perm.download ? "☑️" : "✖️"}
                        </td>
                        <td className="text-center">
                          {perm.delete ? "☑️" : "✖️"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </TableWrapper>
              </div>
          </Card>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={submitForm}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        backdrop="static"
        keyboard={false}
        as={Modal.Dialog}
        centered
        show={showEdit}
        onHide={handleClose}
      >
        <Modal.Header>
          <Modal.Title className="h6">Edit User Details</Modal.Title>
          <Button variant="close" aria-label="Close" onClick={handleClose} />
        </Modal.Header>
        <Modal.Body>
          <Card className="mb-2 mt-2">
            <Row>
              <Col md={12}>
                <Table
                  responsive
                  className="table-centered table-nowrap rounded mb-0 "
                >
                  <tbody>
                    <tr>
                      <td className="border-0">Name</td>
                      <td className="border-0">
                        <input
                          type="text"
                          value={editDetails.name || ""}
                          onChange={(e) =>
                            setEditDetails({
                              ...editDetails,
                              name: e.target.value,
                            })
                          }
                          className="form-control"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td className="border-0">Phone Number</td>
                      <td className="border-0">
                        <div className="input-group phone-input-group">
                          <PhoneInput
                            country="IN"
                            value={editDetails.phone || ""}
                            onChange={(value) => {
                              if (!value) {
                                // If the input is cleared, reset the phone number
                                setEditDetails({ ...editDetails, phone: "" });
                                return;
                              }

                              // Ensure the phone number starts with +91
                              const formattedPhone = value.startsWith("+91")
                                ? value
                                : `${value.replace(/^\+91\s*/, "")}`;

                              verifyPhone(formattedPhone);
                              setEditDetails({
                                ...editDetails,
                                phone: formattedPhone,
                              });
                            }}
                            placeholder="+91 99999-99999"
                            style={{ width: "100%" }}
                          />

                          {isVerifiedPhone === true && (
                            <InputGroup.Text className="phone-input-icon">
                              <CheckIcon width={20} className="text-success" />
                            </InputGroup.Text>
                          )}
                          {isVerifiedPhone === false && (
                            <InputGroup.Text className="phone-input-icon">
                              <XCircleIcon
                                width={20}
                                className="text-danger "
                              />
                            </InputGroup.Text>
                          )}
                        </div>
                        <div className="invalid-feedback d-block">
                          Please enter a valid phone number.
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td className="border-0">Email</td>
                      <td className="border-0">
                        <div className="input-group">
                          <span className="input-group-text">
                            <MailIcon width={20} />
                          </span>
                          <input
                            type="email"
                            value={editDetails.email || ""}
                            onChange={(e) => {
                              verifyEmail(e);
                              setEditDetails({
                                ...editDetails,
                                email: e.target.value,
                              });
                            }}
                            placeholder="name@company.com"
                            className="form-control"
                            required
                            title="Enter a valid email address"
                          />
                          {isVerifiedEmail && (
                            <span className="input-group-text">
                              <CheckIcon width={20} className="text-success" />
                            </span>
                          )}
                          {isVerifiedEmail === false && (
                            <span className="input-group-text">
                              <XCircleIcon width={20} className="text-danger" />
                            </span>
                          )}
                        </div>
                        <div className="invalid-feedback">
                          Please enter a valid email address.
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td className="border-0">Password</td>
                      <td className="border-0">
                        <div className="input-group">
                          {isEditPassword ? (
                            <>
                              <span className="input-group-text">
                                <KeyIcon width={20} />
                              </span>
                              <input
                                required
                                type="password"
                                maxLength={8}
                                placeholder="Password"
                                autoComplete="new-password"
                                value={editDetails.password || password}
                                onChange={handlePasswordChange} // Use the new handler here
                                className={`form-control ${
                                  passwordError ? "is-invalid" : ""
                                }`}
                                title="Password must be 8-32 characters, include uppercase, lowercase, number, and special character."
                              />
                              <span
                                className="input-group-text"
                                onClick={generatePassword}
                                style={{ cursor: "pointer" }}
                                title="Auto-generate password"
                              >
                                <MdOutlineAutoMode size={20} />
                              </span>
                              {passwordError && (
                                <div className="invalid-feedback">
                                  {passwordError}
                                </div>
                              )}
                            </>
                          ) : (
                            <Button
                              variant="light"
                              onClick={() =>
                                setIsEditingPassword(!isEditingPassword)
                              }
                              title="Click to edit password"
                            >
                              <CiEdit size={25} />
                            </Button>
                          )}
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td className="border-0">Expiry Date</td>
                      <td className="border-0">
                        <input
                          type="date"
                          value={
                            editDetails.expiry_date
                              ? moment(
                                  editDetails.expiry_date,
                                  "YYYY/MM/DD"
                                ).format("DD/MM/YYYY")
                              : ""
                          }
                          onChange={(e) => {
                            const newDate = e.target.value;
                            // Convert from YYYY-MM-DD to YYYY/MM/DD if that's your preferred format
                            const formattedDate =
                              moment(newDate).format("YYYY/MM/DD");
                            setEditDetails({
                              ...editDetails,
                              expiry_date: formattedDate,
                            });
                          }}
                          className="form-control"
                          title="Select the expiry date for this user account"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td className="border-0">User Currency</td>
                      <td className="border-0">
                        <div className="form-group mb-0">
                          <Select
                            options={currencyOptions} // Provide your options here
                            placeholder="Select Currency"
                            className="mb-0"
                            isSearchable={true}
                            value={currencyOptions.find(
                              (option) =>
                                option.value === editDetails.user_currency
                            )}
                            onChange={(selectedOption) =>
                              setEditDetails({
                                ...editDetails,
                                user_currency: selectedOption
                                  ? selectedOption.value
                                  : "",
                              })
                            }
                            // Ensure the dropdown appears over the card
                            menuPortalTarget={document.body} // Attach the dropdown to the body
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }), // High z-index
                            }}
                          />
                        </div>
                      </td>
                    </tr>

                    {editDetails.user_type_id === 4 && (
                      <tr>
                        <td className="border-0">CRM Manager</td>
                        <td className="border-0">
                          <div className="form-group mb-0">
                            <Select
                              options={selectedCrmEditOptions}
                              placeholder="Select User"
                              className="mb-0"
                              isSearchable={true}
                              value={
                                coordinatedEditCrm || selectedCrmEditOptions[0]
                              }
                              onChange={setCoordinatedEditCrm}
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                              }}
                            />
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Col>
            </Row>
          </Card>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            /* onClick={submitEditForm} */ onClick={handleEditSubmit}
          >
            Preview
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        backdrop="static"
        keyboard={false}
        as={Modal.Dialog}
        centered
        show={isEditingPassword && !isEditPassword}
        onHide={handleClose}
      >
        <Modal.Header>
          <Modal.Title className="h6">Edit Password Confirmation</Modal.Title>
          <Button
            variant="close"
            aria-label="Close"
            onClick={() => setIsEditingPassword(!isEditingPassword)}
          />
        </Modal.Header>
        <Modal.Body>
          <p>Once confirmed, you will be required to update your password.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setIsEditPassword(!isEditPassword);
              setEditDetails((prevDetails) => ({
                ...prevDetails,
                password: "",
              }));
            }}
          >
            Confirm
          </Button>
          <Button
            variant="link"
            className="text-gray ms-auto"
            onClick={() => setIsEditingPassword(!isEditingPassword)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        backdrop="static"
        keyboard={false}
        as={Modal.Dialog}
        centered
        show={showEditDefault}
        onHide={handleCloseBack}
      >
        <Modal.Header>
          <Modal.Title className="h6">Editted User Detail Preview</Modal.Title>
          <Button
            variant="close"
            aria-label="Close"
            onClick={handleCloseBack}
          />
        </Modal.Header>
        <Modal.Body>
          <Card className="mb-2 mt-2">
            <Row>
              <Col md={10}>
                <Table
                  responsive
                  className="table-centered table-nowrap rounded mb-0"
                >
                  <tbody>
                    <tr>
                      <td className="border-0">Name</td>
                      <td className="border-0">{editDetails.name}</td>
                    </tr>
                    <tr>
                      <td className="border-0">Phone Number</td>
                      <td className="border-0">{editDetails.phone}</td>
                    </tr>
                    <tr>
                      <td className="border-0">Email</td>
                      <td className="border-0">{editDetails.email}</td>
                    </tr>
                    {editDetails.password !== undefined && (
                      <tr>
                        <td className="border-0">Password</td>
                        <td className="border-0">{editDetails.password}</td>
                      </tr>
                    )}
                    <tr>
                      <td className="border-0">Expiry Date</td>
                      <td className="border-0">
                        {editDetails.expiry_date
                          ? moment(editDetails.expiry_date).format("DD/MM/YYYY")
                          : ""}
                      </td>
                    </tr>
                    {editDetails.user_type_id === 4 && (
                      <tr>
                        <td className="border-0">Coordinated CRM</td>
                        <td className="border-0">
                          {coordinatedEditCrm?.label
                            ? coordinatedEditCrm?.label
                            : selectedCrmEditOptions[0].label}
                        </td>
                      </tr>
                    )}

                    <tr>
                      <td className="border-0">User Currency</td>
                      <td className="border-0">
                        {editDetails?.user_currency?.label ||
                          editDetails.user_currency}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
              <Col md={2} className="d-flex align-items-start">
                <Card.Body className="d-flex flex-column">
                  <div>
                    {copied ? (
                      <Button
                        size="sm"
                        variant="success"
                        className="copy-code-button"
                      >
                        Copied
                      </Button>
                    ) : (
                      <CopyToClipboard
                        text={`Name: ${name}\nUsername: ${enterpriseName}\nPhone Number: ${phone}\nEmail: ${email}\nPassword: ${password}\nExpiry Date: ${
                          birthday ? moment(birthday).format("DD/MM/YYYY") : ""
                        }\n${
                          crmValue === "2"
                            ? `Coordinated CRM: ${
                                coordinatedCrm ? coordinatedCrm.label : ""
                              }\n`
                            : ""
                        }User Type: ${
                          userType ? userType.label : ""
                        }\nUser Currency: ${currency ? currency.label : ""}`}
                        onCopy={handleCopy}
                      >
                        <Button
                          size="sm"
                          variant="secondary"
                          className="copy-code-button"
                        >
                          Copy
                        </Button>
                      </CopyToClipboard>
                    )}
                  </div>
                </Card.Body>
              </Col>
            </Row>
          </Card>

          <Card className="mb-2 mt-3">
            <Row>
              <Col md={12}>
                <Card.Body>
                  <b>Share Details:</b>
                  <FormCheck type="switch" className="mt-2">
                    <FormCheck.Input
                      type="checkbox"
                      id="emailSwitch"
                      checked={selectedOption === "email"}
                      onChange={() => setSelectedOption("email")}
                    />
                    <FormCheck.Label
                      htmlFor="emailSwitch"
                      style={{ marginLeft: "8px" }}
                    >
                      Email ID
                    </FormCheck.Label>
                  </FormCheck>
                  <FormCheck type="switch" className="mt-2">
                    <FormCheck.Input
                      type="checkbox"
                      id="phoneSwitch"
                      checked={selectedOption === "phone"}
                      onChange={() => setSelectedOption("phone")}
                    />
                    <FormCheck.Label
                      htmlFor="phoneSwitch"
                      style={{ marginLeft: "8px" }}
                    >
                      Phone Number
                    </FormCheck.Label>
                  </FormCheck>
                  <FormCheck type="switch" className="mt-2">
                    <FormCheck.Input
                      type="checkbox"
                      id="bothSwitch"
                      checked={selectedOption === "both"}
                      onChange={() => setSelectedOption("both")}
                    />
                    <FormCheck.Label
                      htmlFor="bothSwitch"
                      style={{ marginLeft: "8px" }}
                    >
                      Both
                    </FormCheck.Label>
                  </FormCheck>
                  <FormCheck type="switch" className="mt-2">
                    <FormCheck.Input
                      type="checkbox"
                      id="noneSwitch"
                      checked={selectedOption === ""}
                      onChange={() => setSelectedOption("")}
                    />
                    <FormCheck.Label
                      htmlFor="noneSwitch"
                      style={{ marginLeft: "8px" }}
                    >
                      None
                    </FormCheck.Label>
                  </FormCheck>
                </Card.Body>
              </Col>
            </Row>
          </Card>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={(e) => submitEditForm(e)}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
